import { onCLS, onINP, onLCP, onTTFB } from "web-vitals/attribution";

// 性能指标阈值
const THRESHOLDS = {
  CLS: 0.1, // Cumulative Layout Shift
  FID: 100, // First Input Delay
  LCP: 2500, // Largest Contentful Paint
  TTFB: 800, // Time to First Byte
};

// 性能指标上报函数
const reportWebVitals = (metric: any) => {
  const { name, value } = metric;

  // 根据阈值判断性能等级
  const getPerformanceLevel = (value: number, threshold: number) => {
    if (value <= threshold) return "good";
    if (value <= threshold * 1.5) return "needs-improvement";
    return "poor";
  };

  // 获取性能等级
  const level = getPerformanceLevel(
    value,
    THRESHOLDS[name as keyof typeof THRESHOLDS]
  );

  // 构建性能数据
  const performanceData = {
    name,
    value,
    level,
    timestamp: new Date().toISOString(),
    url: window.location.href,
  };

  // 这里可以添加您的上报逻辑，例如发送到后端API
  console.log("Performance Metric:", performanceData);

  // 如果性能较差，可以触发告警
  if (level === "poor") {
    console.warn(`Poor performance detected for ${name}:`, value);
  }
};

// 初始化性能监控
export const initPerformanceMonitoring = () => {
  // 监控累积布局偏移 (CLS)
  onCLS(reportWebVitals);

  // 监控首次输入延迟 (FID)
  onINP(reportWebVitals);

  // 监控最大内容绘制 (LCP)
  onLCP(reportWebVitals);

  // 监控首字节时间 (TTFB)
  onTTFB(reportWebVitals);
};
